import React from "react";

import { Icons, Text } from "@evvve/ui-kit";

import NotificationTemplate from "../NotificationTemplate";

import { TheEventHasBeenCancelledMessage } from "../../../types";

import styles from "./style.module.scss";

type Props = {
  message: TheEventHasBeenCancelledMessage;
};

const TheEventHasBeenCancelled = ({ message }: Props) => (
  <NotificationTemplate>
    <div className={styles.info}>
      <Icons.Info color="tangerine1000" size="s" />
      <Text size="m" color="tangerine1000">
        {"The event has been cancelled"}
      </Text>
    </div>
    <Text size="m"
      as="p">{ message.eventTitle }</Text>
  </NotificationTemplate>
);

export default TheEventHasBeenCancelled;
